// removed by extract-text-webpack-plugin
module.exports = {"title":"EmailConfirmationFailure__title___vvITx"};